const DOT = '.';

const getSubDomain = () => {
  const { hostname } = window.location;
  const domains = hostname.split(DOT);
  if (domains.length > 2) {
    return domains.reduce((pre, cur, index) => {
      if (index === 0) {
        return '';
      }
      if (index === 1) {
        return cur;
      }
      return `${pre}${DOT}${cur}`;
    });
  }
  return hostname;
};

export const createCookie = (name, value, days = 365, shouldUseSubDomain = false) => {
  const date = new Date();
  let expires = '';
  if (days) {
    // eslint-disable-next-line no-mixed-operators
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  const domain = shouldUseSubDomain ? `; domain=${getSubDomain()}` : '';
  document.cookie = `${name}=${value}${expires}${domain}; path=/`;
};

export const readCookie = (name, { cookie = '' } = {}) => {
  let cookieStr = '';
  if (typeof document === 'undefined') {
    cookieStr = cookie;
  } else {
    cookieStr = document.cookie;
  }

  const nameEQ = `${name}=`;
  const ca = cookieStr.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export const eraseCookie = name => {
  createCookie(name, '', -1);
};
